export default {"aBC": "(a)+(b)+(c)",
  "aboutUs": "About us",
  "accountDetail": "Account Detail",
  "accountStatus": "Account Status",
  "action": "Action",
  "active": "Active",
  "activeConsumesLicense": "Active (consumes license)",
  "activateDriver": "Activate driver",
  "activateDriverTooltip": "The driver will consume one license.",
  "activateCar": "Activate car",
  "activateCarTooltip": "The car will consume one license.",
  "activities": "Activities",
  "activity": "Activity",
  "activityTime": "Activity time",
  "activityTimes": "Activity Times",
  "adddriver": "Adddriver",
  "addLicences": "Add Licences",
  "addNewAddresses": "Add New Addresses",
  "addNewAudits": "Add New Audits",
  "addNewBookletPage": "Add New Booklet Page",
  "addnewcardriver": "Assign Driver",
  "addNewCarDriver": "Assign Driver",
  "addNewCars": "Add New Cars",
  "addNewClients": "Add New Clients",
  "addNewConfig": "Add New Config",
  "addNewContractItens": "Add New Contract Itens",
  "addNewContracts": "Add New Contracts",
  "addNewDrivercar": "Add New Drivercar",
  "addNewDriverCar": "Add New Driver Car",
  "addNewDrivers": "Add New Drivers",
  "addNewFleets": "Add New Fleets",
  "addNewItens": "Add New Itens",
  "addNewLists": "Add New Lists",
  "addNewPermDriver": "Add New Perm Driver",
  "addNewPermiDriver2": "Add New Permi Driver2",
  "addNewPermiFleet2": "Add New Permi Fleet2",
  "addNewPermissions": "Add New Permissions",
  "addNewProducts": "Add New Products",
  "addNewReports": "Add New Reports",
  "addNewReportsLog": "Add New Reports Log",
  "addNewRequests": "Add New Requests",
  "addNewTabledisplaylabel": "Add New {TableDisplayLabel}",
  "addNewUserdriver": "Add New Userdriver",
  "addNewUsers": "Add New Users",
  "address": "Address",
  "addresses": "Addresses",
  "addressesAddress": "Addresses Address",
  "addressesCep": "Addresses Cep",
  "addressesCity": "Addresses City",
  "addressesClient": "Addresses Client",
  "addressesContact": "Addresses Contact",
  "addressesContracts": "Addresses Contracts",
  "addressesDateCreated": "Addresses Date Created",
  "addressesDateUpdated": "Addresses Date Updated",
  "addressesDetail": "Addresses Detail",
  "addressesDetails": "Addresses Details",
  "addressesDriver": "Addresses Driver",
  "addressesDrivers": "Addresses Drivers",
  "addressesEmail": "Addresses Email",
  "addressesL1": "Addresses L1",
  "addressesL2": "Addresses L2",
  "addressesLocality": "Addresses Locality",
  "addressesNifNipc": "Addresses Nif Nipc",
  "addressesObs": "Addresses Obs",
  "addressesPhone": "Addresses Phone",
  "addressesReference": "Addresses Reference",
  "addressesReviewedBy": "Addresses Reviewed By",
  "addressesState": "Addresses State",
  "addressesSystem": "Addresses System",
  "admin": "Admin",
  "admission": "Admission",
  "agreeTerms": "Agree Terms",
  "allRightsReserved": "All Rights Reserved",
  "alreadyExist": " Already exist!",
  "alreadyHaveAnAccount": "Already have an account?",
  "alterarAosDadosDeAcessoSomentePeloProprioUtilizador": "Alterar aos dados de acesso somente pelo proprio utilizador",
  "anual": "Anual",
  "application": "Application",
  "aquivado": "Aquivado",
  "arquivada": "Arquivada",
  "arquivadas": "Arquivadas",
  "arquivado": "Arquivado",
  "archiveDriver": "Archive driver",
  "archiveDriverTooltip": "The driver will no longer consume a license and can be reactivated at any time.",
  "archiveCar": "Archive car",
  "archiveCarTooltip": "The car will no longer consume a license and can be reactivated at any time.",
  "replaceCar": "Replace car",
  "replaceCarTooltip": "Replace this car with a new one, transferring all driver assignments.",
  "replaceCarSubmit": "Confirm replacement",
  "replacementInfo": "Replacement information",
  "oldCarRegister": "Previous registration",
  "replacementDriverWarning": "All drivers assigned to this car will be transferred to the new car.",
  "replacementSummary": "Replacement summary",
  "replacementDetails": "Replacement details",
  "oldCar": "Previous car",
  "newCar": "New car",
  "driverAssignmentsUpdated": "Driver assignments updated",
  "replacementProcessing": "Replacement processing...",
  "ativa": "Ativa",
  "ativas": "Ativas",
  "atividade": "Atividade",
  "ativo": "Ativo",
  "ativosLicenas": "Ativos/Licenças",
  "atLeastOneCarRequired": "The driver needs at least one vehicle assigned to record activities.",
  "atribuidoAosCondutores": "Atribuido aos condutores",
  "audits": "Audits",
  "auditsDetails": "Audits Details",
  "available": "Available",
  "availablePlural": "Available",
  "assignedPlural": "Assigned",
  "Available": "Available",
  "Drive": "Drive",
  "Pause": "Pause",
  "Rest": "Rest",
  "Other work": "Other work",
  "Other job": "Other job",
  "Otherwork": "Other work",
  "Otherjob": "Other job",
  "availColor": "Avail Color",
  "back": "Back",
  "birth": "Birth",
  "blocked": "Blocked",
  "bookletPage": "Booklet Page",
  "bookletPageDetails": "Booklet Page Details",
  "brand": "Brand",
  "browse": "Browse...",
  "button": "Button",
  "calender": "Calender",
  "cancel": "Cancel",
  "capitalLetter": "Capital Letter",
  "car": "Car",
  "cars": "Cars",
  "carsBookletPage": "Cars Booklet Page",
  "carsBrand": "Cars Brand",
  "carsCar": "Cars Car",
  "carsClient": "Cars Client",
  "carsDateCreated": "Cars Date Created",
  "carsDateUpdated": "Cars Date Updated",
  "carsDetail": "Cars Detail",
  "carsDetails": "Cars Details",
  "carsDrivercar": "Cars Drivercar",
  "carsFleet": "Cars Fleet",
  "carsModel": "Cars Model",
  "carsRegister": "Cars Register",
  "carsRegisterDate": "Cars Register Date",
  "carsStatus": "Cars Status",
  "category": "Category",
  "cc": "Cc",
  "cep": "Cep",
  "changeEmail": "Change Email",
  "changepass": "changepass",
  "changepassword": "changepassword",
  "changePassword": "Change Password",
  "changeYouPassword": "Change you password",
  "charactersMinimum": "Characters minimum",
  "checkingAvailability": "Checking availability ...",
  "chooseFilesOrDropFilesHere": "Choose files or drop files here",
  "city": "City",
  "clickHereToLogin": "Click here to login",
  "client": "Client",
  "clientactivecontracts": "Clientactivecontracts",
  "clientContract": "Client Contract",
  "clientContractDetails": "Client Contract Details",
  "clientcontracts": "clientContracts",
  "clientName": "Client Name",
  "clientorders": "clientOrders",
  "clientRequests": "Client Requests",
  "clients": "Clients",
  "clientsActivity": "Clients Activity",
  "clientsAddresses": "Clients Addresses",
  "clientsClient": "Clients Client",
  "clientsDateCreated": "Clients Date Created",
  "clientsDateUpdated": "Clients Date Updated",
  "clientsDetail": "Clients Detail",
  "clientsDetails": "Clients Details",
  "clientSince": "Client since",
  "clientsLicense": "Clients License",
  "clientsLogo": "Clients Logo",
  "clientsName": "Clients Name",
  "clientsNipc": "Clients Nipc",
  "clientsObs": "Clients Obs",
  "clientsProduct": "Clients Product",
  "clientsReviewedBy": "Clients Reviewed By",
  "clientsStatus": "Clients Status",
  "close": "Close",
  "closed": "Closed",
  "code": "Code",
  "color": "Color",
  "condutores": "Condutores",
  "condutoresAtivos": "Condutores ativos",
  "condutoresNaAplicaoDriverEGerentesNaFleet": "Condutores na aplicação  'driver' e Gerentes na 'fleet'.",
  "condutoresNaAplicaoDriverEGerentesNaFleetOAcessoPoderSerRealizadoNoNomeDoUtilizador": "Condutores na aplicação  'driver' e Gerentes na 'fleet'.  O Acesso poderá ser realizado no nome do Utilizador",
  "config": "Config",
  "configDetails": "Config Details",
  "configParameter": "Config Parameter",
  "confirmNewPassword": "Confirm new password",
  "confirmPassword": "Confirm Password",
  "confirmTheRequest": "Confirm the request.",
  "confirmTheRequestYouWillReceiveAnEmailWithPaymentDetailsLicenseActivationWillOccurAfterPaymentConfirmation": "Confirm the request. You will receive an email with payment details. License activation will occur after payment confirmation.",
  "congratulations": "Congratulations!",
  "contact": "Contact",
  "contactEmail": "Contact Email",
  "contactSystemAdmin": "Please contact the system administrator for more information",
  "contactUs": "Contact us",
  "continue": "Continue",
  "connectivity": {
    "online": "API Online",
    "offline": "No access",
    "connecting": "Checking connection...",
    "noConnection": "Could not access the server",
    "needInternet": "No internet connection or temporary network failure.",
    "reconnected": "Server access restored",
    "yourIpIs": "Your access IP:",
    "restrictedAccess": "Restricted Access",
    "regionalRestrictionInfo": "We detected that your access comes from a network address (IP) with security restrictions.",
    "whatToDo": "What to do?",
    "contactSupportWithIp": "Please disable any VPN, Proxy or Firewall that may be simulating a location outside Portugal and try again. If the problem persists, contact support providing the IP below."
  },
  "network": {
    "online": "API Online",
    "offline": "No access",
    "noConnection": "Could not access the server",
    "needInternet": "No internet connection or temporary network failure.",
    "reconnected": "Server access restored",
    "yourIpIs": "Your access IP:",
    "tapToRetry": "No connection. Tap here to try again.",
    "retrying": "Connecting... stabilizing connection"
  },
  "contract": "Contract",
  "contractItens": "Contract Itens",
  "contractItensDetails": "Contract Itens Details",
  "contractRenewd": "Contract Renewd",
  "contracts": "Contracts",
  "contractsAddress": "Contracts Address",
  "contractsClient": "Contracts Client",
  "contractsContract": "Contracts Contract",
  "contractsContractItens": "Contracts Contract Itens",
  "contractsDateActivated": "Contracts Date Activated",
  "contractsDateCreated": "Contracts Date Created",
  "contractsDateDeactivated": "Contracts Date Deactivated",
  "contractsDateDue": "Contracts Date Due",
  "contractsDateIssued": "Contracts Date Issued",
  "contractsDatePayed": "Contracts Date Payed",
  "contractsDateUpdated": "Contracts Date Updated",
  "contractsDetail": "Contracts Detail",
  "contractsDetails": "Contracts Details",
  "contractsInvoice": "Contracts Invoice",
  "contractsObs": "Contracts Obs",
  "contractsPayment": "Contracts Payment",
  "contractsPermalink": "Contracts Permalink",
  "contractsProduct": "Contracts Product",
  "contractsRequest": "Contracts Request",
  "contractsReviewedBy": "Contracts Reviewed By",
  "contractsStatus": "Contracts Status",
  "contrata": "contrata",
  "contratoDeTrabalho": "Contrato de trabalho",
  "createRecord": "Create Record",
  "cttItem": "Ctt Item",
  "cttitensduedate": "Cttitensduedate",
  "currentPassword": "Current Password",
  "dadosDeContatatoNoAlteraAcessoDoCondutor": "Dados de contatato (não altera acesso do condutor) ",
  "dadosDeContato": "Dados de contato",
  "dadosParaCadastroDoCondutor": "Dados para cadastro do condutor",
  "dadosParaCadastroDoUtilizador": "Dados para cadastro do utilizador",
  "dark": "dark",
  "dataImportedSuccessfully": "Data imported successfully",
  "date": "Date",
  "dateActivated": "Date Activated",
  "dateCreated": "Date Created",
  "dateDeactivated": "Date Deactivated",
  "dateDue": "Date Due",
  "dateFrom": "Date From",
  "dateIssued": "Date Issued",
  "datePayed": "Date Payed",
  "dateTo": "Date To",
  "dateUpdated": "Date Updated",
  "dateValidity": "Date Validity",
  "day": "Day",
  "defaultcar": "Defaultcar",
  "delete": "Delete",
  "deleteAccount": "Delete Account",
  "deleteRecord": "Delete record",
  "deleteSelected": "Delete Selected",
  "deleteThisRecord": "Delete this record",
  "description": "Description",
  "discount": "Discount",
  "dontHaveAnAccount": "Don't Have an Account?",
  "drive": "Drive",
  "driveA": "Drive (a)",
  "driveColor": "Drive Color",
  "driver": "Driver",
  "driverActivities": "Driver activities",
  "driverCalendar": "Driver Calendar",
  "driverCalendarDetails": "Driver Calendar Details",
  "drivercar": "Drivercar",
  "drivercarDetails": "Drivercar Details",
  "drivers": "Drivers",
  "driversAdmission": "Drivers Admission",
  "driversBirth": "Drivers Birth",
  "driversCategory": "Drivers Category",
  "driversClient": "Drivers Client",
  "driversDateCreated": "Drivers Date Created",
  "driversDateUpdated": "Drivers Date Updated",
  "driversDetail": "Drivers Detail",
  "driversDetails": "Drivers Details",
  "driversDriver": "Drivers Driver",
  "driversDriverCalendar": "Drivers Driver Calendar",
  "driversDrivercar": "Drivers Drivercar",
  "driversEmail": "Drivers Email",
  "driversHomeAddress": "Drivers Home Address",
  "driversLicense": "Drivers License",
  "driversName": "Drivers Name",
  "driversNif": "Drivers Nif",
  "driversObs": "Drivers Obs",
  "driversSelfemployed": "Drivers Selfemployed",
  "driversStatus": "Drivers Status",
  "statusFiledPending": "Filed and Migrated",
  "driverTransferredMessage": "This user is in another company. To return, they must be filed in the current company and proceed as a new registry.",
  "driversWrkAddress": "Drivers Wrk Address",
  "driversWrkFone": "Drivers Wrk Fone",
  "duration": "Duration",
  "eachNewLicenseAdds1OneVehicleAnd1OneDriver": "Each new license adds 1 (one) vehicle and 1 (one) driver.",
  "edit": "Edit",
  "editAccount": "Edit Account",
  "editAddresses": "Edit Addresses",
  "editar": "Editar",
  "editBookletPage": "Edit Booklet Page",
  "editCars": "Edit Cars",
  "editClients": "Edit Clients",
  "editConfig": "Edit Config",
  "editContractItens": "Edit Contract Itens",
  "editContracts": "Edit Contracts",
  "editDrivercar": "Edit Drivercar",
  "editDrivers": "Edit Drivers",
  "editFleets": "Edit Fleets",
  "editItens": "Edit Itens",
  "editLists": "Edit Lists",
  "editMyAccount": "Edit my account",
  "editPermDriver": "Edit Perm Driver",
  "editPermiDriver2": "Edit Permi Driver2",
  "editPermiFleet2": "Edit Permi Fleet2",
  "editPermissions": "Edit Permissions",
  "editProducts": "Edit Products",
  "editReports": "Edit Reports",
  "editReportsLog": "Edit Reports Log",
  "editTabledisplaylabel": "Edit {TableDisplayLabel}",
  "editThisRecord": "Edit This Record",
  "editUserdriver": "Edit Userdriver",
  "editUsers": "Edit Users",
  "email": "Email",
  "emailAddressChanged": "Email address changed successfully",
  "emailAddressNotRegistered": "Email address is not registered",
  "emailAddressVerified": "Email address is already verified",
  "emailNotChanged": "Email not changed",
  "emailOrPhoneNumber": "Email or Phone Number",
  "emailVerificationCompleted": "Email verification completed.",
  "emailVerificationResent": "Email verification has been resent",
  "emailVerificationSent": "Email verification link sent",
  "emailVerifiedAt": "Email Verified At",
  "endDate": "End Date",
  "endDay": "End Day",
  "endKm": "End Km",
  "endTime": "End Time",
  "enterAccountStatus": "Enter Account Status",
  "enterActivity": "Enter Activity",
  "enterAdmission": "Enter Admission",
  "enterAgreeTerms": "Enter Agree Terms",
  "enterApplication": "Enter Application",
  "enterAvailColor": "Enter Avail Color",
  "enterBirth": "Enter Birth",
  "enterBrand": "Enter Brand",
  "enterCar": "Enter Car",
  "enterCategory": "Enter Category",
  "enterCc": "Enter Cc",
  "enterCep": "Enter Cep",
  "enterCity": "Enter City",
  "enterClient": "Enter Client",
  "enterClosed": "Enter Closed",
  "enterCode": "Enter Code",
  "enterConfigParameter": "Enter Config Parameter",
  "enterContact": "Enter Contact",
  "enterContactEmail": "Enter Contact Email",
  "enterContractRenewd": "Enter Contract Renewd",
  "enterDateActivated": "Enter Date Activated",
  "enterDateDeactivated": "Enter Date Deactivated",
  "enterDateDue": "Enter Date Due",
  "enterDateFrom": "Enter Date From",
  "enterDateIssued": "Enter Date Issued",
  "enterDatePayed": "Enter Date Payed",
  "enterDateTo": "Enter Date To",
  "enterDateValidity": "Enter Date Validity",
  "enterDescription": "Enter Description",
  "enterDiscount": "Enter Discount",
  "enterDriveColor": "Enter Drive Color",
  "enterDriver": "Enter Driver",
  "enterDrivers": "Enter Drivers",
  "enterEmail": "Enter Email",
  "enterEmailVerifiedAt": "Enter Email Verified At",
  "enterEndKm": "Enter End Km",
  "enterFielddisplaylabel": "Enter {FieldDisplayLabel}",
  "enterFleet": "Enter Fleet",
  "enterFormat": "Enter Format",
  "enterFpasschange": "Enter Fpasschange",
  "enterFuelLiters": "Enter Fuel Liters",
  "enterHomeAddress": "Enter Home Address",
  "enterIncome": "Enter Income",
  "enterInvoice": "Enter Invoice",
  "enterIva": "Enter Iva",
  "enterL1": "Enter L1",
  "enterL2": "Enter L2",
  "enterLabel": "Enter Label",
  "enterLicense": "Enter License",
  "enterLicenses": "Enter Licenses",
  "enterLocality": "Enter Locality",
  "enterLog": "Enter Log",
  "enterLogo": "Enter Logo",
  "enterManagerEmailOk": "Enter Manager Email Ok",
  "enterManagerNameOk": "Enter Manager Name Ok",
  "enterManagerTelOk": "Enter Manager Tel Ok",
  "enterMaxCars": "Enter Max Cars",
  "enterMaxDrivers": "Enter Max Drivers",
  "enterMaxFleets": "Enter Max Fleets",
  "enterModel": "Enter Model",
  "enterName": "Enter Name",
  "enterNif": "Enter Nif",
  "enterNifNipc": "Enter Nif Nipc",
  "enterNipc": "Enter Nipc",
  "enterNipcNifOk": "Enter Nipc Nif Ok",
  "enterObs": "Enter Obs",
  "enterOjobColor": "Enter Ojob Color",
  "enterOtherExpense": "Enter Other Expense",
  "enterOtp": "Enter OTP",
  "enterOworkColor": "Enter Owork Color",
  "enterPassword": "Enter Password",
  "enterPauseColor": "Enter Pause Color",
  "enterPayment": "Enter Payment",
  "enterPermalink": "Enter Permalink",
  "enterPermission": "Enter Permission",
  "enterPhone": "Enter Phone",
  "enterPrice": "Enter Price",
  "enterProduct": "Enter Product",
  "enterPvp": "Enter Pvp",
  "enterQuantity": "Enter Quantity",
  "enterReference": "Enter Reference",
  "enterRegister": "Enter Register",
  "enterRegisterDate": "Enter Register Date",
  "enterReviewedBy": "Enter Reviewed By",
  "enterSelfemploed": "Enter Selfemploed",
  "enterSelfemployed": "Enter Selfemployed",
  "enterStartKm": "Enter Start Km",
  "enterState": "Enter State",
  "enterStatus": "Enter Status",
  "enterSystem": "Enter System",
  "enterText": "Enter Text",
  "enterTheCode": "Enter the code",
  "enterTimeallowance": "Enter Timeallowance",
  "enterTo": "Enter To",
  "enterType": "Enter Type",
  "enterUnit": "Enter Unit",
  "enterUser": "Enter User",
  "enterUserName": "Enter User Name",
  "enterUserRoleId": "Enter User Role Id",
  "enterValue": "Enter Value",
  "enterWrkAddress": "Enter Wrk Address",
  "enterWrkFone": "Enter Wrk Fone",
  "errorDeletingRecord": "Error deleting the record. please make sure that the record exit",
  "errorInsertingRecord": "Error inserting record",
  "errorProcessingRequest": "Error processing request!",
  "errorRegisteringUser": "Error registering user",
  "errorSendingEmail": "Error sending email. Please contact system administrator for more info",
  "errorUploadingFile": "Error uploading file",
  "excluir": "Excluir",
  "export": "Export",
  "exportCsv": "Export CSV",
  "exportExcel": "Export Excel",
  "exportPageFields": "Export Page Fields",
  "exportWord": "Export Word",
  "failedJobs": "Failed Jobs",
  "false": "false",
  "filed": "Filed",
  "filedNotConsumesLicense": "Filed (does not consume license)",
  "fileFormatNotSupported": "File format not supported",
  "filename": "Filename",
  "files2": "Files2",
  "filterByStatus": "Filter by Status",
  "fleet": "Fleet",
  "fleetManager": "FLeet Manager",
  "fleets": "Fleets",
  "fleetsApplication": "Fleets Application",
  "fleetsCars": "Fleets Cars",
  "fleetsClient": "Fleets Client",
  "fleetsDetail": "Fleets Detail",
  "fleetsDetails": "Fleets Details",
  "fleetsFleet": "Fleets Fleet",
  "fleetsName": "Fleets Name",
  "format": "Format",
  "formIsInvalid": "Form is invalid",
  "fpasschange": "Fpasschange",
  "fpasswordchange": "fpasswordchange",
  "fuelLiters": "Fuel Liters",
  "geolocations": "Geolocations",
  "helpAndFaq": "Help and FAQ",
  "hi": "Hi",
  "home": "Home",
  "homeAddress": "Home Address",
  "id": "Id",
  "importData": "Import Data",
  "incio": "Início",
  "income": "Income",
  "invalidCaptchaCode": "Invalid captcha code",
  "invalidEmailVerifyLink": "The email verification link is not valid",
  "invalidRequest": "Invalid request",
  "invoice": "Invoice",
  "item": "Item",
  "itens": "Itens",
  "itensDetails": "Itens Details",
  "iva": "Iva",
  "l1": "L1",
  "l2": "L2",
  "label": "Label",
  "language": "Language",
  "lastCarAccessed": "last car accessed",
  "latitude": "Latitude",
  "license": "License",
  "licenses": "Licenses",
  "limit": "Limit",
  "line": "Line",
  "listaddress": "Address List",
  "listdrivers": "Listdrivers",
  "listfleet": "Fleet List",
  "lists": "Lists",
  "listsDetails": "Lists Details",
  "loading": "Loading...",
  "loadMore": "Load More",
  "locality": "Locality",
  "log": "Log",
  "logId": "Log Id",
  "login": "Login",
  "loginCompleted": "Login completed",
  "logo": "Logo",
  "logoff": "logoff",
  "logout": "Logout",
  "longitude": "Longitude",
  "manager": "Manager",
  "managerEmailOk": "Manager Email Ok",
  "managerNameOk": "Manager Name Ok",
  "managerTelOk": "Manager Tel Ok",
  "maxCars": "Max Cars",
  "maxDrivers": "Max Drivers",
  "maxFleets": "Max Fleets",
  "migrations": "Migrations",
  "model": "Model",
  "myAccount": "My Account",
  "mycompany": "myCompany",
  "myplan": "myPlan",
  "name": "Name",
  "nenhumRegistroEncontrado": "Nenhum Registro Encontrado",
  "newPassword": "New Password",
  "newValues": "New Values",
  "nif": "Nif",
  "nifNipc": "Nif Nipc",
  "nipc": "Nipc",
  "nipcNifOk": "Nipc Nif Ok",
  "no": "Não",
  "noFileSelectedForUpload": "No file selected for upload",
  "noMoreContentToLoad": "No more content to load",
  "noRecordFound": "No Record Found",
  "noRecordInserted": "No record inserted",
  "noRecordUpdated": "No record updated",
  "noRequestFound": "No request found",
  "notAvailable": "Not available",
  "number": "Number",
  "oAcessoAoSistemaPodeSerRealizadoPeloNomeDoUtilizador": "O acesso ao sistema pode ser realizado pelo nome do utilizador. ",
  "oauthAccessTokens": "Oauth Access Tokens",
  "oauthAuthCodes": "Oauth Auth Codes",
  "oauthClients": "Oauth Clients",
  "oauthPersonalAccessClients": "Oauth Personal Access Clients",
  "oauthRefreshTokens": "Oauth Refresh Tokens",
  "obs": "Obs",
  "of": "of",
  "ojobColor": "Ojob Color",
  "oldValues": "Old Values",
  "ordaerDate": "Ordaer date",
  "order": "Order",
  "orderDate": "Order Date",
  "orderUpdated": "Order Updated",
  "otherExpense": "Other Expense",
  "otherJob": "Other Job",
  "otherJobC": "Other Job (c)",
  "otherWork": "Other Work",
  "otherWorkB": "Other Work (b)",
  "otpSentEmail": "OTP has been sent to your email",
  "otpSentSMS": "OTP has been sent to your phone number via SMS",
  "otpVerification": "OTP Verification",
  "oUtilizadorDeveAlterarNoDriverOuNoFleetOsDadosDeAcesso": "O utilizador deve alterar no 'driver' ou no 'fleet' os dados de acesso.",
  "oworkColor": "Owork Color",
  "page": "Page",
  "password": "Password",
  "passwordChangedMsg": "Your password has been changed successfully",
  "passwordHint": "Hints : Not Less Than 6 Characters",
  "passwordReset": "Password Reset ",
  "passwordResetKeyFailure": "Password reset key failure",
  "passwordResetLinkMsg": "A link will be sent to your email containing the information you need for your password",
  "passwordResetMsg": "A message has been sent to your email. Kindly follow the link to reset your password",
  "passwordResets": "Password Resets",
  "passwordResetStepsMsg": "Please you can try reseting your password by following these steps ",
  "pauseColor": "Pause Color",
  "payment": "Payment",
  "pendente": "Migrated",
  "pendenteAguardaRevisoActivoEmCobrana": "Pendente: Aguarda revisão / Activo: em cobrança",
  "pendenteAguardaRevisoAtivoEmCobrana": "Pendente: Aguarda revisão / Ativo: em cobrança",
  "pendentes": "Pendentes",
  "pending": "Migrated",
  "permalink": "Permalink",
  "permDriver": "Perm Driver",
  "permDriverDetails": "Perm Driver Details",
  "permiadmin2": "Permiadmin2",
  "permiDriver2": "Permi Driver2",
  "permiDriver2Details": "Permi Driver2 Details",
  "permiFleet": "Permi Fleet",
  "permiFleet2": "Permi Fleet2",
  "permiFleet2Details": "Permi Fleet2 Details",
  "permission": "Permission",
  "permissionId": "Permission Id",
  "permissions": "Permissions",
  "permissionsDetails": "Permissions Details",
  "permiVendas2": "Permi Vendas2",
  "permiVendas3": "Permi Vendas3",
  "phone": "Phone",
  "phoneNumber": "Phone Number",
  "photo": "Photo",
  "places": "Places",
  "pleaseAChooseFile": "Please a choose file",
  "pleaseCompleteTheForm": "Please complete the form",
  "pleaseEnterText": "Please enter text",
  "pleseConfirmTheRequest": "Plese confirm the request.",
  "price": "Price",
  "print": "Print",
  "printPageSettings": "Print Page Settings",
  "printPdf": "Print | PDF",
  "privacyPolicy": "Privacy Policy",
  "product": "Product",
  "productName": "Product Name",
  "products": "Products",
  "productsClients": "Products Clients",
  "productsDetail": "Products Detail",
  "productsDetails": "Products Details",
  "promptAccountBlocked": "Your account has been blocked",
  "promptAccountCreated": "Your account has been created.",
  "promptAccountInReview": "Your account is waiting for review",
  "promptAccountNotActive": "Your account is not active. Please contact system administrator for more information",
  "promptDeleteRecord": "Are you sure you want to delete this record?",
  "promptDeleteRecords": "Are you sure you want to delete these records?",
  "promptEmailNotRegistered": "The email address or NIF is not registered on the system",
  "promptForValidEmail": "Please provide the valid email or NIF you used to register",
  "promptPasswordConfirmFail": "Your password confirmation is not consistent",
  "promptPasswordExpired": "Your password has expired. Please reset your password to continue.",
  "promptPasswordResetFailed": "Your password reset was not completed",
  "provideNewPassword": "Provide new password",
  "pvp": "Pvp",
  "quantity": "Quantity",
  "recordAddedSuccessfully": "Record added successfully",
  "recordDeletedSuccessfully": "Record deleted successfully",
  "recordId": "Record Id",
  "records": "Records",
  "recordUpdatedSuccessfully": "Record updated successfully",
  "reference": "Reference",
  "registaParaUtilizar": "Register to use",
  "register": "Register",
  "registerDate": "Register Date",
  "registroExcludoComSucesso": "Registro excluído com sucesso",
  "rememberMe": "Remember Me",
  "removePageLinks": "Remove Page Links",
  "removerAtribuio": "Remover atribuição",
  "report": "Report",
  "reports": "Reports",
  "reportsDetails": "Reports Details",
  "reportsLog": "Reports Log",
  "reportsLogDetails": "Reports Log Details",
  "request": "Request",
  "requestInProcess": "Request in process",
  "requestInProcessing": "Request in processing\r\n.",
  "requests": "Requests",
  "requestsContracts": "Requests Contracts",
  "requestsDetail": "Requests Detail",
  "requestUrl": "Request Url",
  "resendEmail": "Resend Email",
  "resetcookies": "Reset Cookies",
  "resetPassword": "Reset Password",
  "forgotPassword": "Forgot your password?",
  "rest": "Rest",
  "reverse": "Reverse",
  "reviewedBy": "Reviewed By",
  "roleId": "Role Id",
  "roleName": "Role Name",
  "roles": "Roles",
  "rolesadmin": "Rolesadmin",
  "rolesDetail": "Roles Detail",
  "rolesPermissions": "Roles Permissions",
  "rolesUsers": "Roles Users",
  "savePng": "Save PNG",
  "saving": "Saving...",
  "search": "Search",
  "selectAFileToImport": "Select a file to import",
  "selectAValue": "Select a value ...",
  "selectPaperSize": "Select Paper Size",
  "selfemploed": "Selfemploed",
  "selfemployed": "Selfemployed",
  "send": "Send",
  "shouldContain": "Should contain",
  "showHeader": "Show Header",
  "sim": "Sim",
  "somenteContatato": "somente contatato: ",
  "somenteDadosDeContatatoNoAlteraAcessoDoCondutor": "Somente dados de contatato (não altera acesso do condutor: ",
  "sortBy": "Sort By",
  "startDate": "Start Date",
  "startDay": "Start Day",
  "startEnd": "Start End",
  "startEndDetails": "Start End Details",
  "startKm": "Start Km",
  "startTime": "Start Time",
  "state": "State",
  "status": "Status",
  "statusDuration": "Status Duration",
  "submit": "Submit",
  "success": "Success",
  "supportedFileTypes": "Supported file types",
  "symbol": "Symbol",
  "system": "System",
  "tabledisplaylabelDetails": "{TableDisplayLabel} Details",
  "temCertezaDeQueDesejaExcluirEsteRegistro": "Tem certeza de que deseja excluir este registro?",
  "termsAndConditions": "Terms and Conditions",
  "teste": "teste",
  "text": "Text",
  "theDashboard": "The Dashboard",
  "thisPageIsForNewDriversOnlyToTransferAnExistingDriverPleaseContactSupport": "This page is for new drivers only. To transfer an existing driver, please contact support",
  "timeallowance": "Timeallowance",
  "timestamp": "Timestamp",
  "to": "To",
  "total": "Total",
  "totalHoursDay": "Total Hours Day",
  "totalValue": "Total value",
  "totalWorkingHours": "Total working hours",
  "trabalhadorPorContaPropria": "Trabalhador por conta propria",
  "trmino": "Término",
  "true": "true",
  "tstatus": "tstatus",
  "type": "Type",
  "unableToConnect": "Unable to establish connection...",
  "unableToCompleteRequest": "Unable to complete request.",
  "developedBy": "Solution developed by Fusão Eterea - Unip. Lda., &copy; 2025",
  "unit": "Unit",
  "unitiCost": "Uniti Cost",
  "update": "Update",
  "updateRecord": "Update Record",
  "user": "User",
  "userAgent": "User Agent",
  "userdriver": "Userdriver",
  "userdriverDetails": "Userdriver Details",
  "userId": "User Id",
  "userIp": "User Ip",
  "userLogin": "User Login",
  "username": "Username",
  "userName": "User Name",
  "usernameEmailPhoneNumber": "Username / Email / Phone Number",
  "usernameOrEmail": "Email or NIF",
  "usernameOrPasswordNotCorrect": "Username or password not correct",
  "usernameOrPhoneNumber": "Username or Phone Number",
  "userRegistration": "User registration",
  "userRoleId": "User Role Id",
  "users": "Users",
  "usersDetails": "Users Details",
  "value": "Value",
  "vdsRequests": "Vds Requests",
  "verify": "Verify",
  "verifyEmailLinkMsg": "Please verify your email address by following the link in your mailbox",
  "view": "View",
  "viewMore": "view more",
  "viewRecord": "View Record",
  "viso": "Visão",
  "vnculo": "Vínculo",
  "week": "Week",
  "weekstartdate": "Weekstartdate",
  "welcome": "Welcome",
  "wrkAddress": "Wrk Address",
  "wrkFone": "Wrk Fone",
  "wsday": "Wsday",
  "youNeedToLogInAgain": "You need to log in again",
  managerPage: {
    welcomeTitle: "Welcome to Livrete Fleet!",
    welcomeDescription: "This is your management platform as a transport operator.<br><br>Here, you can create and manage drivers and vehicles, assign which drivers can drive certain vehicles, monitor the activities of all drivers and generate reports for management and inspection.<br><br><strong>Register your first vehicle.</strong>",
    doNotShowAgain: "Do not show again",
    paymentReferenceTitle: "Payment reference",
    paymentDataTitle: "Payment data",
    paymentInstruction: "Use this data to complete the billing.",
    method: "Method",
    entity: "Entity",
    reference: "Reference",
    amount: "Amount",
    validUntil: "Valid until",
    guidelinesDrivers: "Guidelines - Drivers",
    driversWithoutCarAlert: "There are {count} drivers with no assigned vehicle. Check and assign them to avoid operational blocks.",
    guidelinesCars: "Guidelines - Vehicles",
    carsWithoutDriverAlert: "There are {count} active vehicles with no assigned driver. Check and assign them to avoid operational blocks.",
    guidelinesContracts: "Guidelines - Contracts",
    contractsDueAlert: "There are ${count} contracts with expired validity or expiring in the next 30 days.",
    contractLabel: "Contract",
    validity: "validity",
    waitBillingRenewal: "Wait for the billing to pay for the renewal.",
    expiresTodayWaitBilling: "Expires today. Wait for the billing to pay for the renewal.",
    expiresInDaysWaitBilling1: "Expires in {days} day.",
    expiresInDaysWaitBilling: "Expires in {days} days.",
    guidelinesBillings: "Guidelines - Billings",
    activeBillingsAlert: "There are ${count} active billings for contracts. Click on method/validity to see the payment data.",
    warnFiledDrivers: "Attention: Licenses ({lic}) - Active ({act}) - Contract Drivers ({ctr}) = {bal}. Upon expiration of this contract, all active drivers will be filed.",
    warnFiledCars: "Attention: Licenses ({lic}) - Active Vehicles ({act}) - Contract Vehicles ({ctr}) = {bal}. Upon expiration of this contract, all active vehicles will be filed.",
    cars: "Vehicles",
    activeLicensesCars: "Active/Licenses",
    startManagingFleet: "Get ready to manage your fleet like never before!",
    manageFleetDescription: "Here, you will control vehicles, drivers, monitor driving activities and team work, and generate essential reports.<br><strong>Shall we begin?</strong> Follow these simple steps:<br>1. <strong>Register your first vehicle:</strong> Enter all required data.<br>2. <strong>Register your first driver:</strong> Fill in the requested info and assign the vehicles they can use.",
    wantIncreaseCars: "Want to increase the number of vehicles?",
    changePlan: "Change plan",
    fleets: "Fleets",
    groupCarsToFacilitate: "Group vehicles to facilitate management",
    drivers: "Drivers",
    activeLicensesDrivers: "Active/Licenses",
    noDriversRegistered: "There are no registered drivers",
    registerFirstDriverText: "<strong>Register your first driver:</strong> Fill in the requested info and assign the vehicles they can use.",
    wantIncreaseDrivers: "Want to increase the number of drivers?",
    workLocations: "Work Locations",
    manageWorkLocations: "Manage the work locations of your drivers",
    contractInRenewal: "Contract in renewal",
    request: "Request",
    paymentMethod: "Payment method",
    type: "Type: {method}",
    ok: "Ok"
  },
  myPlanPage: {
    cancelRequestTitle: "Confirmation",
    cancelRequestMsg: "Do you want to cancel this pending request?",
    requestCanceled: "Request canceled successfully.",
    buyMoreLicenses: "Buy more licenses.",
    request: "Request",
    pendingRequestAlert: "There is a pending request.",
    cancel: "Cancel"
  },
  carsPage: {
    onboardingTitle: "Get ready to manage your fleet like never before!",
    onboardingDesc: "Here, you will control cars, drivers, monitor driving activities and team work, and generate essential reports.",
    letsStart: "Shall we start?",
    followSteps: "Follow these simple steps:",
    step1Title: "Register Your First Car:",
    step1Desc: "Enter all mandatory data.",
    step2Title: "Register Your First Driver:",
    step2Desc: "Fill in the requested information and associate the cars they can use.",
    assignCar: "Assign Car",
    assignCarsCount: "Assign Cars ({count})",
    selectDriverFirst: "Select a driver before assigning cars.",
    carAssignedSuccess: "Car(s) assigned successfully!"
  },
  driversPage: {
    yes: "Yes",
    no: "No",
    noDriverRegisteredTitle: "No Driver Registered",
    noDriverRegisteredDesc: "Let's organize your fleet? Before adding a driver, make sure the car they use is already registered in the system.",
    assignDriver: "Assign Driver",
    assignDriversCount: "Assign Drivers ({count})",
    selectCarFirst: "Select a vehicle before assigning drivers.",
    driverAssignedSuccess: "Driver(s) assigned successfully!",
    availableDrivers: "Available Drivers"
  },
  connectivity: {
    restrictedAccess: "We detected that your access comes from a network address (IP) with security restrictions.",
    whatToDo: "What to do?",
    contactSupportWithIp: "Please contact technical support and provide your public IP to request access.",
    yourIpIs: "Your IP is:"
  },
  network: {
    online: "API Online",
    offline: "no access",
    noConnection: "Could not access the server",
    needInternet: "No internet connection or temporary network failure.",
    reconnected: "Server access restored",
    yourIpIs: "Your access IP:",
    tapToRetry: "No connection. Tap here to try again.",
    retrying: "Connecting... stabilizing connection"
  },
  copy: "Copy",
  goToHomePage: "Back to Home Page",

	validations: {
		required: "Value is required.",
		undefined: "Value is required.",
		email: "Value is not a valid email address",
		minLength: "This field should be at least ${min} characters long",
		maxLength: "The maximum length allowed is ${max}",
		minValue: "The minimum value allowed is ${min}",
		maxValue: "The maximum value allowed is ${max}",
		numeric: "Value must be numeric",
		ipAddress: "The value is not a valid IP address",
		sameAs: "The value must be equal to the ${otherName} value",
	}
}
